import { render, staticRenderFns } from "./tomanTransactionDetail.vue?vue&type=template&id=4e3315ad&scoped=true"
import script from "./tomanTransactionDetail.vue?vue&type=script&lang=js"
export * from "./tomanTransactionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3315ad",
  null
  
)

export default component.exports